<template>
  <div
    class="friend-details"
  >
    <mk-drawer
      id="friend-details-dialog"
      :visible="visible"
      size="100%"
      class="friend-details-dialog"
      hide-header
      direction="rtl"
      :modal="false"
      tabindex="9"
      @close="onClose"
      @open="onOpen"
    >
      <div
        class="dialog-header"
        tabindex="0"
      >
        <div class="main-info">
          <div class="avatarUrl">
            <img :src="friendData.avatarUrl">
          </div>
          <div class="nickName">
            {{ friendData.nickName }}
          </div>
          <div class="gender">
            <mk-iconfont
              icon-class="wx-user"
              class="gender-icon"
              :style="{
                color: friendData.gender === 1 ? '#009cff' : '#ff6b6b'
              }"
            />
          </div>
        </div>
        <div class="other-info">
          <div class="other-info-item">
            <div class="txt">
              地区
            </div>
            <div class="con">
              {{ (friendData.country ==='中国' ? friendData.country + '/' + friendData.province + '/' + friendData.city: friendData.country) || '无' }}
            </div>
          </div>
          <div class="other-info-item">
            <div class="txt">
              手机号
            </div>
            <div class="con">
              {{ friendData.phoneNumber || '无' }}
            </div>
          </div>
          <div class="other-info-item">
            <div class="txt">
              互动次数
            </div>
            <div class="con">
              <mk-popover
                placement="right-start"
                trigger="hover"
              >
                <span
                  slot="reference"
                  class="text-btn"
                >{{ friendData.count }}</span>
                <div>
                  <div
                    v-for="(item, index) in friendData.clueUA"
                    :key="index"
                  >
                    <div v-if="item.platform === 'WPN'">
                      访问H5：{{ item.visitCount }}次
                    </div>
                    <div v-else-if="item.platform === 'MINI'">
                      访问小程序：{{ item.visitCount }}次
                    </div>
                  </div>
                </div>
              </mk-popover>
            </div>
          </div>
          <div class="other-info-item">
            <div class="txt">
              标签评分
            </div>
            <div class="con">
              {{ friendData.tagScoreTotal }}
            </div>
          </div>
          <div
            class="other-info-item source-item"
          >
            <div class="txt">
              来源轨迹
            </div>
            <div class="con">
              {{ friendData.firstVisitTime ?
                friendData.firstVisitTime.slice(0, 16) : ''
              }}{{ friendData.fromSceneText ? ' 通过 ' + getTxt(friendData.fromSceneText) : '' }} <span
                class="text-btn"
                @click="openClueTrackDialog"
              >查看详情</span>
            </div>
          </div>
        </div>
        <mk-iconfont
          icon-class="guanbi"
          class="close"
          @click.native="onClose"
        />
      </div>
      <div class="dialog-body">
        <div class="has-connect">
          <mk-popover
            placement="bottom-start"
            trigger="hover"
            popper-class="friend-details-popover"
          >
            <div
              v-show="activeName === 'three'"
              slot="reference"
              class="button"
            >
              <mk-iconfont icon-class="gzsj"></mk-iconfont>
              <span
                class="tip-info"
              >已关联工作手机微信好友</span>
            </div>
            <div class="popover-container">
              <div class="title">
                关联微信好友信息
              </div>
              <div class="friend-info">
                <div class="head-portrait">
                  <div class="img">
                    <img
                      :src="friendData.avatarUrl"
                      height="40"
                      width="40"
                    />
                  </div>
                </div>
                <div class="friend-nick">
                  <div class="nick-name">
                    {{ friendData.nickName }}
                  </div>
                  <div class="remarks">
                    备注：
                    <span
                      v-for="(item, index) in popoverData"
                      :key="index"
                    >
                      {{ item.ConRemark }}
                      <template v-if="index !== popoverData.length - 1">、</template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="title">
                添加此好友的员工微信号
              </div>
              <div class="wx-no">
                <span
                  v-for="(item, index) in popoverData"
                  :key="index"
                  class="wx-no-nick-name"
                >
                  {{ item.M7AgentNick }}
                  <template v-if="index !== popoverData.length - 1">、</template>
                </span>
              </div>
            </div>
          </mk-popover>
        </div>
      </div>
      <div
        v-loading="loading"
        class="other-info"
      >
        <mk-tabs-biz
          v-model="activeName"
          class="other-info-tabs el-tabs-mk-ui-mini"
          @tab-click="handleClick"
        >
          <mk-tab-pane
            label="行为轨迹"
            name="one"
          ></mk-tab-pane>
          <mk-tab-pane
            label="标签"
            name="two"
          ></mk-tab-pane>
          <mk-tab-pane
            v-if="friendData.isSyncWPContact"
            label="微信会话"
            name="three"
          ></mk-tab-pane>
          <!-- <mk-tab-pane
            label="分析"
            name="four"
          ></mk-tab-pane> -->
        </mk-tabs-biz>
        <div

          class="other-info-details"
          @scroll="handleScroll"
        >
          <interaction
            v-if="activeName === 'one'"
            :key="key"
            :union-id="friendData.unionId"
            :user-id="friendData.userId"
            :ev="ev"
            @loading="loadingInteraction"
          ></interaction>
          <attribute-label
            v-else-if="activeName === 'two'"
            :clue-id="friendData.unionId"
          ></attribute-label>
          <wx-conversation
            v-else-if="activeName === 'three'"
            :friend-data="friendData"
            @getFriendInfo="getFriendInfo"
          ></wx-conversation>
          <analysis
            v-else-if="activeName === 'four'"
            :clue-id="friendData.unionId"
          ></analysis>
        </div>
      </div>
    </mk-drawer>
    <clue-track
      v-if="clueTrackVisible"
      :visible.sync="clueTrackVisible"
      :union-id="friendData.unionId"
    ></clue-track>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Interaction from './components/interaction'
import AttributeLabel from './components/attribute-label'
import WxConversation from './components/wx-conversation'
import Analysis from './components/analysis'
import ClueTrack from './components/clue-track'
let that
function handleBlur (params) {
  that.onClose()
}
export default {
  name: 'FriendDetails',
  components: {
    Interaction,
    AttributeLabel,
    WxConversation,
    Analysis,
    ClueTrack
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    friendData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 当前好友id
    friendId: {
      type: String,
      default: ''
    },
    // 当前坐席微信id
    agentId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 当前tab
      activeName: 'one',
      // 已关联工作手机微信好友popover数据
      popoverData: {},
      ev: {},
      // key每次刷新组件
      key: '',
      // 线索轨迹弹窗是否可见
      clueTrackVisible: false,
      // 线索是否被关注
      isFocus: false,
      // 是否正在关注
      isFocusLoading: false,
      // 判断是不是管理员
      isAdmin: false,
      loading: true
    }
  },
  watch: {
    friendData: {
      handler (val) {
        this.activeName = 'one'
        this.key = Number(new Date().getTime())
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    that = this
    let unionId = this.friendData.unionId
    // this.wxclueIsFocusGet(unionId)
    this.judgeIsAdmin()
  },
  mounted () {
    setTimeout(() => {
      let ele = document.getElementById('friend-details-dialog')
      // ele.setAttribute('tabindex', 10)
      ele.focus()
      // ele.addEventListener('blur', handleBlur)
      // 300ms为动画时长
    }, 300)
  },
  methods: {
    getTxt (txt) {
      let str = ''
      if (txt.indexOf('/') > 0) {
        str += txt.split('/')[1] + '的' + txt.split('/')[0] + ' 成为线索'
      }
      return str
    },
    loadingInteraction (state) {
      this.loading = state
    },
    getKey () {
      return dayjs(new Date()).unix()
    },
    onClose () {
      this.$emit('update:visible', false)
    },
    onOpen () {
      this.activeName = 'one'
      this.key = dayjs(new Date()).unix()
    },
    // 查询线索是否关注
    // async wxclueIsFocusGet (unionId) {
    //   let res = await BIZAPIS.WxclueApi.wxclueIsFocusGet({ unionId })
    //   if (res.success) {
    //     this.isFocus = res.data
    //   }
    // },
    // 判断是不是管理员
    judgeIsAdmin () {
      let userInfo = JSON.parse(window.localStorage.getItem('user'))
      if (userInfo.identity === 'admin') {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
    },
    // 关注/取消关注线索
    // async focusClue () {
    //   if (this.isFocusLoading) {
    //     return
    //   }
    //   this.isFocusLoading = true
    //   let params = {
    //     unionId: this.friendData.unionId,
    //     focus: !this.isFocus
    //   }
    //   let res = await BIZAPIS.WxclueApi.wxclueFocusPut(params)
    //   this.isFocusLoading = false
    //   if (res.success) {
    //     if (res.data) {
    //       this.$message.success('关注成功')
    //     } else {
    //       this.$message.info('取消关注成功')
    //     }
    //     this.isFocus = res.data
    //   } else {
    //     this.$message.error('关注失败')
    //   }
    // },
    // 点击tab
    handleClick () {},
    // 子组件获取了当前好友信息之后调用
    getFriendInfo (data) {
      this.popoverData = data
    },
    handleScroll (ev) {
      this.ev = {
        scrollTop: ev.target.scrollTop,
        clientHeight: ev.target.clientHeight,
        scrollHeight: ev.target.scrollHeight
      }
    },
    // 打开线索轨迹弹窗
    openClueTrackDialog () {
      this.clueTrackVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.friend-details {
  background-color: #fff;
  position: fixed;
  right: 0;
  bottom: 0;
  width: 70vw;
  min-width: 800px;
  height: calc(100vh - 64px);
  z-index: 9;
  // box-shadow: 0 0 6px 0 rgba(3, 51, 39, 0.2);
}

.friend-details-dialog {
  width: 70vw;
  min-width: 800px;
  left: inherit;
  height: calc(100vh - 64px);
  top: 64px;
  box-shadow: -2px 1px 4px 0 rgba(0, 0, 0, 0.15);
  animation: rtl-drawer-in 0.3s 1ms;
  outline: none;

  /deep/ .el-drawer__body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .dialog-header {
    flex-shrink: 0;
    max-height: 173px !important;
    background-color: #f6f9fd !important;
    padding: 20px;
    position: relative;
    outline: none;
    box-shadow: -4px 1px 4px 0 rgba(0, 0, 0, 0.15) inset;

    .main-info {
      display: flex;
      flex-direction: row;
      align-items: center;

      .avatarUrl {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 20px;

        img {
          display: block;
          width: 100%;
        }
      }

      .nickName {
        font-size: 16px;
        color: #262626;
        font-weight: 500;
        margin-right: 10px;
      }

      .gender {
        .gender-icon {
          font-size: 14px;
        }
      }
    }

    .other-info {
      display: flex;
      margin-top: 24px;
      flex-direction: row;

      .other-info-item {
        flex: 1;

        .txt {
          font-size: 12px;
          color: #8c8c8c;
          line-height: 17px;
        }

        .con {
          font-size: 13px;
          color: #262626;
          line-height: 18px;
          margin-top: 8px;
        }

        .text-btn {
          cursor: pointer;
          color: #009cff;
        }
      }
    }

    .close {
      position: absolute;
      color: #bfbfbf;
      font-size: 14px;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    .source-item {
      flex-basis: 15%;
      min-width: 390px;
    }
  }

  .dialog-body {
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;

    .table {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 500px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      border: 1px solid rgba(245, 245, 245, 1);

      .table-info {
        display: flex;
        padding: 10px;

        img {
          display: block;
          width: 94px;
          height: 94px;
          border-radius: 8px;
        }

        .table-content {
          flex: 1;
          margin-left: 24px;

          .name {
            margin-bottom: 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            h4 {
              display: flex;
              align-items: center;
              font-size: 14px;
              line-height: 14px;
            }

            .is-sale {
              margin: 0 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: #009cff;
              width: 30px;
              height: 18px;
              border-radius: 2px;
              border: 1px solid rgba(0, 156, 255, 1);
              flex-shrink: 0;
            }

            .is-focus {
              border: 1px solid #a1a1a1;
              color: #a1a1a1;
              box-sizing: border-box;
              width: 60px;
              height: 24px;
              border-radius: 4px;
              font-size: 13px;
              line-height: 22px;
              text-align: center;
            }

            .to-focus {
              border: 1px solid #009cff;
              color: #009cff;
            }
          }

          .table-ul-li {
            font-size: 13px;
            margin: 3px 0;
            line-height: 24px;
            font-weight: 400;
            color: rgba(89, 89, 89, 1);

            .interaction-times {
              color: #009cff;
            }
          }
        }
      }

      .visit-time {
        display: flex;
        justify-content: space-between;
        background-color: #fbfbfb;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        font-weight: 400;
        // color: rgba(191, 191, 191, 1);
        color: #595959;

        .to-find {
          margin-left: 10px;
          color: #009cff;

          .icon-mk-wenhao {
            color: #009cff;
            margin-right: 6px;
          }
        }
      }
    }

    .has-connect {
      display: flex;
      align-items: center;
      width: 100%;
      position: absolute;
      right: 44px;
      top: 14px;
      justify-content: flex-end;

      /deep/ .tip-info {
        color: #595959;
        font-size: 13px;
        line-height: 16px;
      }

      .button {
        height: 26px;
        line-height: 26px;
        padding: 0 10px;

        @extend .cursor;
      }

      .icon-mk-gzsj {
        color: #009cff;
        margin-right: 4px;
      }
    }
  }

  .other-info {
    // margin-top: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    // /deep/ .el-tabs__header .el-tabs__nav-wrap {
    //   padding: 0 20px 0 40px;
    // }

    .other-info-details {
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
    }
  }

  // .text-hide {
  //   text-overflow: ellipsis;
  //   white-space: nowrap;
  // }
  .other-info-tabs {
    position: relative !important;
    z-index: 9999 !important;
  }
}
</style>

<style lang="scss">
.friend-details-popover {
  padding: 20px 20px 4px 20px !important;
  margin: 0 !important;

  .title {
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: #262626;
  }

  .friend-info {
    margin: 10px 0 20px 0;
    display: flex;

    .head-portrait {
      .img {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        overflow: hidden;
      }
    }

    .friend-nick {
      margin-left: 10px;

      .nick-name,
      .remarks {
        max-width: 200px;
      }

      .nick-name {
        color: #262626;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 8px;
      }

      .remarks {
        color: #595959;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }

  .wx-no {
    margin-top: 10px;
    max-width: 200px;

    .wx-no-nick-name {
      display: inline-block;
      height: 22px;
      padding: 0 8px;
      margin-right: 8px;
      line-height: 22px;
      background-color: #ebeff4;
      border-radius: 2px;
      color: #6b7b88;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 8px;
    }
  }

  .tip-info {
    color: #595959;
    font-size: 14px;
  }
}
</style>
